if (!customElements.get('checked-return-selector')) {
  customElements.define(
    'checked-return-selector',
    class CheckedReturnSelector extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.checked-return-card');
        this.fieldset = this.closest('.checked-return-fieldset');
        this.returnInput = this.fieldset?.querySelector('[data-return-option]');
        this.standardInput =
          this.fieldset?.querySelector('[data-standard-option]') ||
          Array.from(this.fieldset?.querySelectorAll('input[type="radio"]') || []).find(
            (input) => input !== this.returnInput
          );

        if (!this.button || !this.returnInput || !this.standardInput) return;

        this.button.addEventListener('click', () => {
          const targetInput = this.returnInput.checked ? this.standardInput : this.returnInput;
          if (targetInput.disabled) return;

          targetInput.checked = true;
          this.updateState();
          targetInput.dispatchEvent(new Event('change', { bubbles: true }));
        });

        this.fieldset.addEventListener('change', () => this.updateState());
        this.updateState();
      }

      updateState() {
        const selected = Boolean(this.returnInput?.checked);
        this.button?.classList.toggle('is-selected', selected);
        this.button?.setAttribute('aria-pressed', selected ? 'true' : 'false');
        this.fieldset?.classList.toggle('is-return-selected', selected);

        const nextLabel = selected ? this.button?.dataset.labelRemove : this.button?.dataset.labelSelect;
        if (nextLabel) this.button?.setAttribute('aria-label', nextLabel);
      }
    }
  );
}
